import * as T from '../../../types/merchants/services';
import * as I from '../../../../interfaces/merchants/services';
import { Actions, Types } from '../../../actions/merchants/services';
import * as $ from '../../../../components/merchants/calendar/helper';

export interface State {
  meta?: I.Meta;
  services: I.ServiceMap;
  fetchedUntil: string;
  viewStyle: T.ViewStyle;
  baseDate: string; // ISO format
  publicId: T.PublicId;
  timeZone: string;
}

const initialState: State = {
  services: {},
  viewStyle: T.ViewStyle.Calendar,
  baseDate: '',
  fetchedUntil: '',
  publicId: '',
  timeZone: $.DEFAULT_TZ,
};

export default (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case Types.Init: {
      const { publicId, timeZone } = action.payload;

      return {
        ...state,
        publicId,
        timeZone,
        baseDate: $.today(timeZone).toISO(),
        fetchedUntil: $.yesterday(timeZone).toISO(),
      };
    }
    case Types.Load: {
      const { services: newServices, fetchedUntil, meta } = action.payload;

      // apiリクエストしない場合、fetch済みのmetaを使う
      const imeta = meta ? $.convertMeta(meta) : state.meta;
      const services = state.services;

      newServices.map(s => {
        const mapKey = $.makeServiceMapKey(s, imeta);
        const servicesBykey = services[mapKey] || [];
        // to filter duplicate service
        const servicesByDigest: { [digest: string]: I.Service } = {};
        [...servicesBykey, $.convert(s)].map(service => {
          servicesByDigest[service.digest] = service;
        });

        services[mapKey] = Object.values(servicesByDigest);
      });

      // 予約日程なしにより抜けてしまっている日付keyを補完
      const eachDates = $.eachDayBetween(
        $.today(state.timeZone),
        $.dateTimeFromISO(fetchedUntil),
      ).map(d => d.toFormat('yyyyMMdd'));
      eachDates.forEach(date => {
        if (!services[date]) {
          services[date] = [];
        }
      });

      return { ...state, services, fetchedUntil, meta: imeta };
    }
    case Types.SwitchViewStyle: {
      return {
        ...state,
        viewStyle: action.payload.viewStyle,
      };
    }
    case Types.MovePrev: {
      switch (state.viewStyle) {
        case T.ViewStyle.Calendar: {
          return { ...state, baseDate: $.prevBaseDate(state.baseDate).toISO() };
        }
        case T.ViewStyle.List: {
          return {
            ...state,
            baseDate: $.prevStartOfMonth(state.baseDate).toISO(),
          };
        }
        default:
          return state;
      }
    }
    case Types.MoveNext: {
      const { baseDate } = state;

      switch (state.viewStyle) {
        case T.ViewStyle.Calendar: {
          return { ...state, baseDate: $.nextBaseDate(baseDate).toISO() };
        }
        case T.ViewStyle.List: {
          return { ...state, baseDate: $.nextStartOfMonth(baseDate).toISO() };
        }
        default:
          return state;
      }
    }
    case Types.ScrollNext: {
      const { baseDate, fetchedUntil } = state;
      const nextBaseDate = $.nextBaseDate(baseDate);
      if ($.stopFetch(baseDate, nextBaseDate, fetchedUntil)) {
        return state;
      }

      return { ...state, baseDate: nextBaseDate.toISO() };
    }
    default:
      return state;
  }
};
